import type React from 'react'
import { useEffect, useState } from 'react'

interface RenameDialogProps {
  open: boolean
  initialName: string
  onSubmit: (newName: string) => Promise<void> | void
  onCancel: () => void
}

const RenameDialog: React.FC<RenameDialogProps> = ({ open, initialName, onSubmit, onCancel }) => {
  const [name, setName] = useState(initialName)
  const [error, setError] = useState<string | null>(null)
  const [busy, setBusy] = useState(false)

  useEffect(() => {
    if (open) {
      setName(initialName)
      setError(null)
      setBusy(false)
    }
  }, [open, initialName])

  const handleSubmit = async () => {
    const trimmed = name.trim()
    if (!trimmed) { setError('Name cannot be empty'); return }
    if (trimmed.length > 120) { setError('Name is too long'); return }
    setBusy(true)
    try {
      await onSubmit(trimmed)
    } catch (e: any) {
      setError(e?.message || 'Rename failed')
    } finally {
      setBusy(false)
    }
  }

  if (!open) return null
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 shadow-xl max-w-md w-full mx-4">
        <h3 className="text-lg font-semibold text-gray-900 mb-2">Rename asset</h3>
        <input
          className="w-full border rounded px-3 py-2 text-sm mb-2"
          value={name}
          onChange={(e) => setName(e.target.value)}
          disabled={busy}
          placeholder="Name"
        />
        {error && <div className="text-sm text-red-600 mb-2">{error}</div>}
        <div className="flex justify-end gap-2">
          <button className="px-3 py-2 text-sm border rounded-md text-gray-700 hover:bg-gray-50" onClick={onCancel} disabled={busy}>Cancel</button>
          <button className="px-3 py-2 text-sm rounded-md bg-blue-600 text-white hover:bg-blue-700 disabled:opacity-50" onClick={handleSubmit} disabled={busy}>Save</button>
        </div>
      </div>
    </div>
  )
}

export default RenameDialog


